import { render } from "./SystemPreferenceInputModal.vue?vue&type=template&id=381ff480"
import script from "./SystemPreferenceInputModal.vue?vue&type=script&lang=js"
export * from "./SystemPreferenceInputModal.vue?vue&type=script&lang=js"

import "./SystemPreferenceInputModal.vue?vue&type=style&index=0&id=381ff480&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__